import CumulativeHoursLineChart from '../Visualisations/adresses/CumulativeHoursLineChart'

// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Shared cumulative-hours line chart for the Housevisits module. Used by
// `DashboardHouseVisitsHoursCard` and the upcoming `HouseVisitsHoursWidget`.
// The caller passes already-aggregated series via `data`; this is a thin
// presentational wrapper so dashboard and widget render identically.

/**
 * @typedef {object} CumulativeHoursDatum
 * @property {string} day - 'YYYY-MM-DD' day key
 * @property {number} hours - Hours worked on this day
 * @property {number} cumulativeHours - Running total of hours up to and including this day
 */

/**
 * @param {object} props
 * @param {Array<CumulativeHoursDatum>} props.data
 * @param {string} props.color
 * @param {string|number} [props.height='100%']
 * @returns {JSX.Element}
 */
const HouseVisitsHoursVisualization = ({ data, color, height = '100%' }) => {
    return (
        <CumulativeHoursLineChart
            data={data}
            color={color}
            height={height}
        />
    )
}

export default HouseVisitsHoursVisualization
